module.exports = new __parcel__URL__("artifact_0003.b0831681.png").toString();